// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DocumentViewer{width:100%;height:90%;border-width:0}", "",{"version":3,"sources":["webpack://./src/common/components/DocumentViewer/DocumentViewer.scss"],"names":[],"mappings":"AAAA,gBACI,UAAA,CACA,UAAA,CACA,cAAA","sourcesContent":[".DocumentViewer {\n    width: 100%;\n    height: 90%;\n    border-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
